import { ChangeEvent, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Modal,
  ModalOverlay,
  useDisclosure,
  ModalContent,
  ModalHeader,
  Heading,
  ModalBody,
  ModalFooter,
  Textarea,
  Select,
} from '@chakra-ui/react'

import { FormItem } from 'components/miscellaneous'
import { CustomFormQuestionOptionsProps } from '../..'

export default function CustomFormAdvancedOptionToSelect({ formMethods, options }: CustomFormQuestionOptionsProps) {
  const [delimiter, setDelimiter] = useState<string>('\n')

  const { register, handleSubmit } = useForm<{ text: string }>({ defaultValues: { text: options.join(delimiter) } })

  const { isOpen, onClose, onOpen } = useDisclosure()

  const handleOnChangeDelimiter = (event: ChangeEvent<HTMLSelectElement>) => {
    const inputValue = event.target.value
    setDelimiter(inputValue)
  }

  const demilitersOptions = useMemo(() => {
    return [{ label: 'Pular linha', value: '\n' }]
  }, [])

  function onSubmit({ text }: { text: string }) {
    const newOptions = text.split(delimiter)
    formMethods.setValue('options', newOptions)
    onClose()
  }

  return (
    <>
      <Button variant="ghost" onClick={onOpen} size="xs">
        Modo avançado
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading>Adicionar opções avançada</Heading>
          </ModalHeader>

          <ModalBody>
            <FormItem label="Delimitadores">
              <Select value={delimiter} onChange={handleOnChangeDelimiter}>
                {demilitersOptions.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Select>
            </FormItem>

            <FormItem label="Lista de opções">
              <Textarea {...register('text')} />
            </FormItem>
          </ModalBody>

          <ModalFooter>
            <Button variant="outline" width="50%" onClick={onClose}>
              Fechar
            </Button>
            <Button width="50%" onClick={() => handleSubmit(onSubmit)()}>
              Salvar opções
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
